
@if (!idAdmStatus) {
  <div class="status-tag"
    [ngClass]="{'endRelease': endRealease == idStatus, 'endDeath': endDeath == idStatus, 'endInternation': endInternation == idStatus, 'endEvasion': endEvasion == idStatus, 'initial': initial == idStatus}">
    {{patientStatus}}
  </div>
}

@if (idAdmStatus) {
  <div class="status-tag"
    [ngClass]="{'endRelease': endRealease == idAdmStatus, 'endDeath': endDeath == idAdmStatus, 'endInternation': endInternation == idAdmStatus, 'endEvasion': endEvasion == idAdmStatus, 'initial': initial == idAdmStatus}">
    Aguardando: {{patientAdmStatus}}
  </div>
}

